import { Avatar, Box, Button, Card, Grid, Typography, Paper } from '@mui/material';
import { PhotoCamera, Edit, Person, Email, Phone, Business, Assessment, Badge } from '@mui/icons-material';
import { theme as colorTheme, palette } from "../../../Convoze.theme"
import UserProfileImg from "../../../assets/ProfileImg.png"
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInterceptors";
import Loader from '../../../components/AnimatedLoader';
import { useEffect, useState } from 'react';


const primary = colorTheme('palette', 'primary').value;

export default function Profile() {
    const token = localStorage.getItem("token");
    const [profile, setProfile] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const res = await axiosInstance.get(apiEndPointsConfig.userProfile, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                console.log('Response of user profile', res)
                setProfile(res.data.data);
            } catch (e) {
                console.error("failed to fetch user profile", e);
            } finally {
                setLoading(false);
            }
        })();
    }, [token]);

    if (loading) return <Loader />;



    return (
        <Grid container spacing={{ xs: 2, md: 3 }}>
            {/*  LEFT –  identity   */}
            <Grid item xs={12} md={4}>
                <Card
                    sx={{
                        p: { xs: 2, md: 3 },
                        textAlign: 'center',
                        bgcolor: 'common.white',
                        border: 1,
                        borderColor: 'grey.200',
                        borderRadius: 3,
                        boxShadow: 0,
                    }}
                >
                    <Box position="relative" width={96} height={96} mx="auto" mb={2}>
                        <Avatar
                            src={UserProfileImg}
                            sx={{ width: 96, height: 96 }}
                        />

                    </Box>

                    <Typography variant="h6" fontWeight={600} color="text.primary">
                        {profile?.firstName}
                    </Typography>
                    <Typography variant="body2" sx={{ color: primary, fontWeight: 500 }}>
                        {profile?.role}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {profile?.product}
                    </Typography>
                </Card>
            </Grid>

            {/*  RIGHT – user details  */}
            <Grid item xs={12} md={8}>
                <Card
                    sx={{
                        p: { xs: 2, md: 3 },
                        border: 1,
                        borderColor: 'grey.200',
                        borderRadius: 3,
                        boxShadow: 0,
                    }}
                >
                    <Typography
                        variant="h6"
                        fontWeight={600}
                        color="text.primary"
                        mb={3}
                        display="flex"
                        alignItems="center"
                        gap={1}
                    >
                        <Badge sx={{ color: primary }} /> Personal Information
                    </Typography>

                    <Grid container spacing={2.5}>
                        {[
                            { icon: <Person sx={{ color: primary }} />, label: 'Full Name', value: `${profile?.firstName}${profile?.lastName}` },
                            { icon: <Email sx={{ color: primary }} />, label: 'Email', value: profile?.email },
                            { icon: <Phone sx={{ color: primary }} />, label: 'Contact', value: profile?.mobile },
                            { icon: <Business sx={{ color: primary }} />, label: 'Role', value: profile?.role },
                            { icon: <Business sx={{ color: primary }} />, label: 'Company', value: profile?.product },
                            { icon: <Assessment sx={{ color: primary }} />, label: 'Industry', value: profile?.industry || 'SaaS – Financial Technology' },
                        ].map((item) => (
                            <Grid item xs={12} sm={6} key={item.label}>
                                <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                                    {item.icon}
                                    <Typography variant="caption" color="text.secondary">
                                        {item.label}
                                    </Typography>
                                </Box>


                                <Typography
                                    variant="body2"
                                    sx={{
                                        p: 2,
                                        bgcolor: 'grey.50',
                                        borderRadius: 2,
                                        color: 'text.primary',
                                    }}
                                >
                                    {item.value}
                                </Typography>


                                
                            </Grid>
                        ))}
                    </Grid>




                </Card>
            </Grid>
        </Grid>
    );
}